import { render, staticRenderFns } from "./MemberPriceList.vue?vue&type=template&id=6e77032a&scoped=true"
import script from "./MemberPriceList.vue?vue&type=script&lang=js"
export * from "./MemberPriceList.vue?vue&type=script&lang=js"
import style0 from "./MemberPriceList.vue?vue&type=style&index=0&id=6e77032a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77032a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e77032a')) {
      api.createRecord('6e77032a', component.options)
    } else {
      api.reload('6e77032a', component.options)
    }
    module.hot.accept("./MemberPriceList.vue?vue&type=template&id=6e77032a&scoped=true", function () {
      api.rerender('6e77032a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/member/MemberPriceList.vue"
export default component.exports